import React from 'react';
export function BonusSection() {
  const bonuses = [{
    num: '1',
    title: 'Lista de compras inteligente + combos semanales',
    desc: 'Sabés exactamente qué comprar cada semana. Sin desperdiciar comida. Sin improvisar en el super.',
    value: '$6.000'
  }, {
    num: '2',
    title: 'Postres en air fryer: 10 recetas dulces',
    desc: 'Desde brownie hasta manzana asada. Todo en la freidora, todo en menos de 20 minutos.',
    value: '$6.000'
  }, {
    num: '3',
    title: 'Guía de "comida chatarra saludable"',
    desc: 'Las versiones sanas de lo que más te gusta: papas fritas, nuggets, empanadas. Sin culpa y sin horno.',
    value: '$6.000'
  }];
  return <section className="py-24 px-4 bg-brand-purple" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <div className="inline-flex bg-brand-yellow text-brand-purpleDark px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wider mb-6" data-id="element-24">
            Bonus exclusivos
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-25">
            Con tu compra hoy recibís 3 regalos
          </h2>
          <p className="text-brand-yellow text-xl md:text-2xl font-bold" data-id="element-26">
            (Valorados en $18.000 ARS — incluidos sin costo extra)
          </p>
        </div>

        <div className="space-y-6" data-id="element-27">
          {bonuses.map((bonus, i) => <div key={i} className="bg-brand-purpleDark border border-white/10 p-6 md:p-8 rounded-2xl flex flex-col md:flex-row gap-6 items-start" data-id="element-28">
              <div className="bg-brand-yellow text-brand-purpleDark w-16 h-16 rounded-2xl flex items-center justify-center font-bold text-2xl flex-shrink-0" data-id="element-29">
                #{bonus.num}
              </div>
              <div className="flex-1" data-id="element-30">
                <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-gray-300 font-medium mb-4 leading-relaxed" data-id="element-32">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-3 font-bold" data-id="element-33">
                  <span className="text-gray-400" data-id="element-34">(valor: {bonus.value})</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}